export default __webpack_public_path__ + "static/media/CapaRegisterConnectUserLogo.1eb8287a.svg";